import './CheckboxScreen.vars.css'

const responsiveStyles = {
  top: 'var(--checkbox-screen-top)',
  right: 'var(--checkbox-screen-right)'
}

export default responsiveStyles
